/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { errorHolderDetailConfig } from '../../config/error.config';
import { ConsoleView } from 'react-device-detect';
export interface IErrorHolderDetailPluginMethods extends IPluginMethodMap {
  getErrorHolderDetailSync(args?: any): any;
}

export class ErrorHolderDetailPlugin implements IAgentPlugin {
  readonly methods: IErrorHolderDetailPluginMethods;

  constructor() {
    this.methods = {
      getErrorHolderDetailSync: this.getErrorHolderDetailSync.bind(this),
    };
  }

  getErrorHolderDetailSync(args?: any) {
    console.log('KYC123 args', args);
    return {
      error: errorHolderDetailConfig,
    };
  }
}
